import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../components/utils/Model';
import Button from '../../../components/utils/Button';
import portinActivationAction from '../../../redux/portinActivation/actions';
import Alert from '../../../components/utils/Alert';

const { refundPortActivation, resetMessage, resetSucessMessage } = portinActivationAction;

const PortinActivationRefund = ({ modal, row, close, search }) => {
    const dispatch = useDispatch();
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const { refundPortActivationLoading, refundPortActivationMessage, refundPortActivationError } = useSelector((state) => state.portinActivation);
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            remark: ''
        }
    });

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
        dispatch(resetSucessMessage());
    }

    useEffect(() => {
        if (refundPortActivationMessage) {
            close();
        }
        if (refundPortActivationError !== null && refundPortActivationError !== undefined) {
            displayAlert(refundPortActivationError, 'alert-danger');
        }

    }, [refundPortActivationMessage, refundPortActivationError]);

    const onSubmit = (data) => {
        dispatch(refundPortActivation({
            activationId: row.ID,
            bulktransactionid: row.BulkTransactionID,
            remark: data.remark,
            search
        }));
    }
    return (
        <Modal
            showModal={modal}
            title={'REFUND PORTIN REQUEST: '}
            subTitle={<span style={{ color: '#990404' }}>{row.TransactionID}</span>}
            onHide={close}
            width={500}
            showFooter={false}
        >
            {showAlert && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-row">
                    <div className="col-md-12 mb-3">
                        <label>Remark</label>
                        <textarea className="form-control" placeholder="Enter Remark" id="remark" name="remark" rows="4" cols="30" {...register("remark", {
                            required: "Remark is required"
                        })}>
                        </textarea>
                        {errors.remark && (<div className="invalid-feedback">{errors.remark.message}</div>)}
                    </div>
                </div>
                <hr />
                <div className='text-right row'>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-secondary mr-2" onClick={close}>Close</button>
                        <Button title="Submit" style="minWidth:80px" loading={refundPortActivationLoading} buttonClass="btn btn-primary" buttonType='submit' />
                    </div>
                </div>
            </form>
        </Modal>
    )
}

export default PortinActivationRefund
